<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-on="http://www.w3.org/1999/xhtml">
	<div>
		<b-modal ref="loaderModal"
			hide-footer
			title="Chargement...">
			<throbber />
			<p class="my-4">{{ $t("Tooltip.message_wait") }}</p>
		</b-modal>
		<b-modal ref="modalError"
			hide-footer
			title="Erreur">
			<lottie_error />
			<p class="my-4">{{ text_error }}</p>
		</b-modal>
		<div class="valid_button">
			<button type="submit"
				class="btn btn-valid"
				:disabled=disabled
				@click="sendDatas">{{ $t("Button.validate") }}
			</button>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import {EventBus} from "../../../event/event-bus.js";
import throbber from "@/components/ui/throbber";
import lottie_error from "@/components/ui/lottie_error";

const BASE_URL = process.env.VUE_APP_BASE_URL;

export default {
	name: "ValidStepSpeech",
	components: {throbber, lottie_error},
	props: {
		valueName: String,
		valueFunction: String,
		muted: Boolean,
		music_enabled: Boolean,
		volume: Number,
		music_volume: Number,
		id: Number,
		// uploadVideoFile: Array,
		valueKeywords: String,
		modal: "",
		// activate_upload: Boolean,
		disabled: Boolean,
	},
	data() {
		return {
			successModif: "L'étape Speech a été modifiée avec succès !",
			text_error: "",
			check: false,
			files: [],
		};
	},
	methods: {
		sendDatas() {
			let $this = this;
			$this.$refs.loaderModal.show();

			let bodyFormData = new FormData();
			bodyFormData.append("_method", "put");
			if (this.valueName !== undefined) {
				bodyFormData.append("title", this.valueName);
			}
			if (this.valueKeywords !== undefined) {
				bodyFormData.append("keywords", this.valueKeywords);
			}
			if (this.valueFunction !== undefined) {
				bodyFormData.append("secondaryTitle", this.valueFunction);
			}
			if (this.muted !== undefined) {
				bodyFormData.append("muted", this.muted ? "true" : "false");
			}
			if (this.music_enabled !== undefined) {
				bodyFormData.append("music_enabled", this.music_enabled ? "true" : "false");
			}
			if (this.volume !== undefined) {
				bodyFormData.append("volume", this.volume.toString());
			}
			if (this.music_volume !== undefined) {
				bodyFormData.append("music_volume", this.music_volume.toString());
			}
			// if (this.uploadVideoFile.length > 0 && this.activate_upload) {
			// 	bodyFormData.append("video", this.uploadVideoFile[0].file);
			// }
			axios.post(BASE_URL + "/public/api/stepSpeeches/" + this.id,
				bodyFormData,
				{
					headers: {
						"Authorization": sessionStorage.getItem("auth"),
					},
				},
			).then(function () {
				$this.$refs.loaderModal.hide();
				EventBus.$emit("isSaved", true);
				// if ($this.uploadVideoFile.length > 0) {
				// 	EventBus.$emit("setStepSpeechComplete", $this.id);
				// }
				EventBus.$emit("stepSpeechReload", $this.id);
				EventBus.$emit("setModified", false);
			})
			.catch(error => {
				$this.text_error = this.$root.$t("Errors.error_detailed") + error;
				$this.$refs.modalError.show();
			});
		},
	},
};
</script>

<style scoped>
.btn-valid {
	background-color: var(--color-validation);
	border-color: var(--color-validation);
	color: var(--text-validation);
	border-radius: var(--small-border-radius);
}
</style>
